import { UnitType } from '@exodus/currency'

const name = 'ripple'
const displayName = 'XRP'
const ticker = 'XRP'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#11AAE2'
const gradientColors = ['#11AAE2', '#016197']
const gradientCoords = { x1: '0%', y1: '0%', x2: '104.002%', y2: '143.585%' }
const chainBadgeColors = gradientColors

const units = {
  drop: 0,
  XRP: 6,
}
const currency = UnitType.create(units)

const assetType = 'RIPPLE_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://xrpscan.com/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://xrpscan.com/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'XRP was created by Ripple as a cryptocurrency designed to offer banks and payment providers a reliable, on-demand option to source liquidity for cross-border payments.',
  reddit: 'https://www.reddit.com/r/Ripple/',
  twitter: 'https://twitter.com/Ripple',
  website: 'https://www.ripple.com/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
